import _ from 'lodash';
import { type UnknownAction } from '@reduxjs/toolkit'

import { ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED, ADD_OPPORTUNITY_TO_SHARE, ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED, ADDING_OPPORTUNITY_TO_SHARE_FAILED, ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED, CONVERSATION_ADD_ASSETS, CONVERSATION_REARRANGE_ASSETS, CONVERSATION_REMOVE_ASSETS, CONVERSATION_UPDATE_ASSET_METADATA, CONVERSATION_UPDATE_PROPERTY, CREATE_CONVERSATION_SECTION_REQUEST, DELETE_CONVERSATION_REQUEST, DELETING_CONVERSATION_FAILED, DELETING_CONVERSATION_SUCCEEDED, EDIT_CONVERSATION_REQUEST, FETCH_ASSETS_FOR_CONVERSATION_REQUEST, FETCH_ASSETS_FOR_SECTION, FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST, FETCH_CONVERSATION_ASSETS_REQUEST, FETCH_CONVERSATION_EVENTS, FETCH_CONVERSATION_REQUEST, FETCH_CONVERSATION_SECTION_REQUEST, FETCH_CONVERSATIONS_REQUEST, FETCH_MESSAGE_REQUEST, FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST, FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST, FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED, FETCHING_ASSETS_FOR_SECTION_FAILED, FETCHING_ASSETS_FOR_SECTION_SUCCEEDED, FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED, FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED, FETCHING_CONVERSATION_ASSETS_SUCCEEDED, FETCHING_CONVERSATION_EVENTS_FAILED, FETCHING_CONVERSATION_EVENTS_SUCCEEDED, FETCHING_CONVERSATION_FAILED, FETCHING_CONVERSATION_SECTION_FAILED, FETCHING_CONVERSATION_SECTION_SUCCEEDED, FETCHING_CONVERSATION_SUCCEEDED, FETCHING_CONVERSATIONS_FAILED, FETCHING_CONVERSATIONS_SUCCEEDED, FETCHING_MESSAGE_FAILED, FETCHING_MESSAGE_SUCCEEDED, FETCHING_PREVIEW_ASSET, FETCHING_PREVIEW_ASSET_FAILED, FETCHING_PREVIEW_ASSET_SUCCEEDED, FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED, FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED, FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED, FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED, INVALIDATE_CONVERSATION_EDIT_STATE, INVALIDATE_CONVERSATION_STATE, INVALIDATE_RESHARE, MOVE_CONVERSATION_SECTION_REQUEST, REMOVE_CONVERSATION_SECTION_REQUEST, REMOVE_OPPORTUNITY_FROM_SHARE, REMOVING_OPPORTUNITY_FROM_SHARE_FAILED, REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED, RESEND_CONVERSATION_REQUEST, RESENDING_CONVERSATION_FAILED, RESENDING_CONVERSATION_SUCCEEDED, SEARCHING_ENTITIES_IN_SHARE_FAILED, SEARCHING_ENTITIES_IN_SHARE_REQUEST, SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED, TOGGLE_VISITOR_SESSION, UPDATE_CONVERSATION_RECIPENT_REQUEST, UPDATE_CONVERSATION_REQUEST, UPDATE_CONVERSATION_SECTION_REQUEST, UPDATING_CONVERSATION_FAILED, UPDATING_CONVERSATION_RECIPENT_FAILED, UPDATING_CONVERSATION_RECIPENT_SUCCEEDED, UPDATING_CONVERSATION_SUCCEEDED, CREATE_CONVERSATION_REQUEST, CREATING_CONVERSATION_FAILED, CREATING_CONVERSATION_SUCCEEDED,INVALIDATE_CREATE_CONVERSATION
 } from '../actions/actionTypes';

import {
  CollectionAsset,
  CollectionEditState,
  CollectionSectionState} from '../../types/collections'

import { nanoid } from 'nanoid';
import { AddAssetToConversationRequest, AddAssetToConversationResponse, AddOpportunityToShare, AddOpportunityToShareErrorResponse, AddOpportunityToShareResponse, ArrangeAssetInConversationRequest, Conversation, ConversationEvents, CreateConversationSectionRequest, DeleteConversationErrorResponse, DeleteConversationRequest, DeleteConversationResponse, FetchAssetsForConversationRequest, FetchAssetsForConversationResponse, FetchAssetsForSection, FetchAssetsForSectionErrorResponse, FetchAssetsForSectionResponse, FetchConversationAssetAnalyticsErrorResponse, FetchConversationAssetAnalyticsRequest, FetchConversationAssetAnalyticsResponse, FetchConversationAssetsResponse, FetchConversationErrorResponse, FetchConversationEventsErrorResponse, FetchConversationEventsRequest, FetchConversationEventsResponse, FetchConversationResponse, FetchConversationSectionErrorResponse, FetchConversationSectionRequest, FetchConversationSectionResponse, FetchConversationsErrorResponse, FetchConversationsResponse, FetchingMessageErrorResponse, FetchingMessageResponse, FetchMessageRequest, FetchRecipientInfoErrorResponse, FetchRecipientInfoRequest, FetchRecipientInfoResponse, FetchRecipientsForConversationErrorResponse, FetchRecipientsForConversationRequest, FetchRecipientsForConversationResponse, InvalidateReshare, Message, MoveConversationSectionRequest, Opportunity, RemoveAssetFromConversationRequest, RemoveOpportunityFromConversationErrorResponse, RemoveOpportunityFromConversationRequest, RenameConversationSectionRequest, ResendMessageErrorResponse, ResendMessageRequest, ResendMessageResponse, SearchEntitiesInShareErrorResponse, SearchEntitiesInShareRequest, SearchEntitiesInShareResponse, Sections, ToggleVisitorSessionRequest, UpdateAssetMetadataRequest, UpdateConversationErrorResponse, UpdateConversationRecipientErrorResponse, UpdateConversationRecipientRequest, UpdateConversationRecipientResponse, UpdateConversationRequest, UpdateConversationResponse, CreateConversationErrorResponse, CreateConversationRequest, CreateConversationResponse, } from 'src/types/conversations';
import { Contact } from 'src/types/contact';
import { Asset, FetchPreviewAsset, FetchPreviewAssetErrorResponse, FetchPreviewAssetResponse } from 'src/types/assets';
import { getContactCardExists } from 'src/utils/collections.helper';

interface ConversationsState {
  update: {
    [key: string]: CollectionUpdateState;
  },
  conversation: {
    [key: string]: any;
    creation: {
      creating: boolean,
      created: boolean,
    }
  }
  edit: CollectionEditState | null,
  conversations: ConversationsListState,
  delete: {
    [key: string]: {
      deleting: boolean,
      deleted: boolean,
      error: any
    }
  }

}
interface ConversationEventsState {
  loading?: boolean,
  loaded?: boolean,
  items?: ConversationEvents[],
  error?: any,
  pagination?: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
  }
}

interface ConversationsListState {
  loading: boolean,
  items: Conversation[],
  error: any,
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  }
}

interface shareEntitiesState {
  loading: boolean,
  error: any,
  succeeded: boolean
  items: {
    assets : Asset | any [],
    contacts: Contact | any [],
  } | null
}

interface MessageState {
  loading: boolean,
  loaded: boolean,
  item: Message | null,
  error?: any,
  resending?: boolean | null
}
export interface ConversationState {
  loading: boolean,
  loaded: boolean,
  loadingAssets: boolean,
  loadedAssets: boolean,
  item: CollectionEditState | null,
  recipients?: ConversationRecipientsState,
  events?: ConversationEventsState,
  shareEntities?: shareEntitiesState,
  message?: MessageState,
  addingDeal?: boolean,
  addedDeal?: boolean,
  error: any;
  assets?: Asset[];
  sections?: Sections[]
}

interface ConversationRecipientsState {
  loading: boolean,
  loaded: boolean,
  items: any[], 
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
  error?: any
}


interface CollectionUpdateState {
  id: string,
  updating: boolean,
  updated: boolean,
  item: Conversation | null,
  error: any
}

const initialState: ConversationsState = {
  update: {},
  conversation: {
    creation: {
      creating: false,
      created: false
    }
  },  
  edit: null,
  conversations: {
    loading: false,
    items: [],
    error: null,
    pagination: {
      currentPage: -1,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
      hasMoreItems: false
    }
  },
  delete: {}
}

const initialConvesationDeleteState = {
  deleting: false,
  deleted: false,
  error: null
}

const initialCollectionUpdateState: CollectionUpdateState = {
  id: '',
  updating: false,
  updated: false,
  item: null,
  error: null,
}

export function conversationsReducer(state: ConversationsState = initialState, action: UnknownAction): ConversationsState {
  switch (action.type) {
    //Fetch Conversations list
    case FETCH_CONVERSATIONS_REQUEST: {
      const { page } = action.payload as { page: number };
      return {
        ...state,
        conversations: {
          ...state.conversations,
          loading: true,
          items: page === 0 ? [] : state.conversations.items,
        },
      };
    }

    case FETCHING_CONVERSATIONS_SUCCEEDED: {
      const { response } = action.payload as FetchConversationsResponse;

      return {
        ...state,
        conversations: {
          loading: false,
          items:
            response.currentPage === 0
              ? response.records
              : [...state.conversations.items, ...response.records],
          error: null,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
            hasMoreItems: response.currentPage < response.totalPages - 1,
          },
        },
      };
    }

    case FETCHING_CONVERSATIONS_FAILED: {
      const { error } = action.payload as FetchConversationsErrorResponse;

      return {
        ...state,
        conversations: {
          ...state.conversations,
          loading: false,
          error: error,
        },
      };
    }

        //Create Conversation
        case CREATE_CONVERSATION_REQUEST: {
          return {
            ...state,
            conversation: {
              ...state.conversation,
              creation: {
                creating: true,
                created: false
              }
            }
          };
        }
    
        case CREATING_CONVERSATION_SUCCEEDED: {
          const {response } = action.payload as CreateConversationResponse;
          
          if (!response || !response.id) {
            return state;
          }
    
          let conversationState = state.conversation[response.id];
          
          const sections = (response.sections || []).map((section): CollectionSectionState => {
            return {
              uid: nanoid(6),
              loading: true,
              loaded: false,
              item: {
                ...section,
                collection: response.id
              },
              error: null
            }
          }) as CollectionSectionState[];
    
          return {
            ...state,
            conversation: {
              ...state.conversation,
              [response.id]: {
                ...conversationState,
                loading: false,
                loaded: true,
                item: {
                  ...response,
                  sections: sections || []
                },
                error: null
              },
              creation: {
                creating: false,
                created: true
              }
            }
          }
        }
    
        case CREATING_CONVERSATION_FAILED: {
          let { error } = action.payload as FetchConversationErrorResponse;
          return {
            ...state,
            conversation: {
              ...state.conversation,
              creation: {
                creating: false,
                created: false
              }
            }
          }
        }
        
        case INVALIDATE_CREATE_CONVERSATION: {
          return {
            ...state,
            conversation: {
              ...state.conversation,
              creation: {
                creating: false,
                created: false
              }
            }
          };
        }

    //Fetch Collection
    case FETCH_CONVERSATION_REQUEST: {
      const id = action.payload as string;

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            loading: true,
            loaded: false,
            loadingAssets: false,
            loadedAssets: false,
            item: null,
            error: null,
          },
        },
      };
    }

    case FETCHING_CONVERSATION_SUCCEEDED: {
      const { response } = action.payload as FetchConversationResponse;

      if (!response || !response.id) {
        return state;
      }

      const conversationState = state.conversation[response.id];
      if (!conversationState) {
        return state;
      }

      const sections = (response.sections || []).map(
        (section): CollectionSectionState => {
          return {
            uid: nanoid(6),
            loading: true,
            loaded: false,
            item: {
              ...section,
              collection: response.id,
            },
            error: null,
          };
        },
      ) as CollectionSectionState[];

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [response.id]: {
            ...conversationState,
            loading: false,
            loaded: true,
            item: {
              ...response,
              sections: sections || [],
            },
            error: null,
          },
        },
      };
    }

    case FETCHING_CONVERSATION_FAILED: {
      const { id, error } = action.payload as FetchConversationErrorResponse;

      const conversationState = state.conversation[id];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            ...conversationState,
            loading: false,
            loaded: false,
            item: null,
            error: error,
          },
        },
      };
    }

    case EDIT_CONVERSATION_REQUEST: {
      const collection = action.payload as CollectionEditState;

      return {
        ...state,
        edit: collection,
      };
    }

    //Fetch assets for conversation
    case FETCH_ASSETS_FOR_CONVERSATION_REQUEST: {
      const { id } = action.payload as FetchAssetsForConversationRequest;

      const conversationState = state.conversation[id];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            ...conversationState,
            loadingAssets: true,
            loadedAssets: false,
          },
        },
      };
    }

    case FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED: {
      const { conversation, response } =
        action.payload as FetchAssetsForConversationResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      let converstationEditState = state.edit;

      const sections = (response.sections || []).map(
        (section): CollectionSectionState => {
          return {
            uid: nanoid(6),
            loading: true,
            loaded: false,
            item: {
              ...section,
              collection: conversation,
            },
            error: null,
          };
        },
      ) as CollectionSectionState[];

      if (converstationEditState) {
        converstationEditState = {
          ...converstationEditState,
          sections: sections,
          entities: response.assets,
        };
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            loadingAssets: false,
            loadedAssets: true,
            item: {
              ...conversationState.item!,
              assets: response.assets,
              sections: sections || [],
            },
          },
        },
        edit: converstationEditState,
      };
    }

    case FETCH_CONVERSATION_ASSETS_REQUEST: {
      const { id } = action.payload as FetchAssetsForConversationRequest;

      const conversationState = state.conversation[id];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            ...conversationState,
            loadingAssets: true,
            loadedAssets: false,
          },
        },
      };
    }

    case FETCHING_CONVERSATION_ASSETS_SUCCEEDED: {
      //NOTE: having sections and assets isolated from item.assets and sections since it is used in edit collections
      const { conversation, response } =
        action.payload as FetchConversationAssetsResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            loadingAssets: false,
            loadedAssets: true,
            assets: response.assets,
            sections: response.sections,
          },
        },
      };
    }

    //Fetch recipients for conversation
    case FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST: {
      const { id } = action.payload as FetchRecipientsForConversationRequest;

      const conversationState = state.conversation[id];
      if (!conversationState) {
        return state;
      }

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              loading: true,
            },
          },
        },
      };
    }

    case FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED: {
      const { conversation, response } =
        action.payload as FetchRecipientsForConversationResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      const existingItems = conversationState.recipients?.items || [];
      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      //records = _.uniqBy(records, 'email');

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            recipients: {
              loading: false,
              loaded: true,
              error: null,
              items: records,
              pagination: {
                currentPage: response.currentPage,
                totalPages: response.totalPages,
                recordsPerPage: response.recordsPerPage,
                totalRecordsCount: response.totalRecordsCount,
                hasMoreItems: response.currentPage < response.totalPages - 1,
              },
            },
          },
        },
      };
    }

    case FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED: {
      const { id, error } =
        action.payload as FetchRecipientsForConversationErrorResponse;

      const conversationState = state.conversation[id];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [id]: {
            ...conversationState,
            recipients: {
              ...conversationState.recipients,
              loading: false,
              loaded: false,
              error: error,
            } as ConversationRecipientsState,
          },
        },
      };
    }

    case FETCH_CONVERSATION_SECTION_REQUEST: {
      const { conversation, section } =
        action.payload as FetchConversationSectionRequest;

      const conversationState = state.conversation[conversation];
      if (!conversationState || !conversationState.item) {
        return state;
      }

      const sections = (conversationState.item.sections || []).map((item) => {
        if (item.item?.id === section) {
          return {
            ...item,
            loading: true,
          };
        }

        return item;
      }) as CollectionSectionState[];

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              sections: sections,
            },
          },
        },
      };
    }

    case FETCHING_CONVERSATION_SECTION_SUCCEEDED: {
      const { conversation, section, response } =
        action.payload as FetchConversationSectionResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState || !conversationState.item) {
        return state;
      }

      const sections = (conversationState.item.sections || []).map((item) => {
        if (item.item?.id === section) {
          return {
            ...item,
            item: {
              ...item.item,
              collection: conversation,
              entities: response.entities,
            },
            loading: false,
            loaded: true,
          };
        }

        return item;
      });

      let editState = state.edit;
      if (editState) {
        const editSections = (editState.sections || []).map((item) => {
          if (item.item?.id === section) {
            const existingAssets = (_.get(item, "item.entities") || []) as CollectionAsset[];

            const newAssets = (response.entities || []).filter(
              (newAsset: CollectionAsset) => !existingAssets.some((existingAsset: CollectionAsset) => existingAsset.id === newAsset.id)
            );
            
            return {
              ...item,
              item: {
                ...item.item,
                collection: conversation,
                entities: [
                  ...existingAssets,
                  ...newAssets
                ],
              },
              loading: false,
              loaded: true,
            };
          }

          return item;
        });

        editState = {
          ...editState,
          sections: editSections,
        };
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              sections: sections,
            },
          },
        },
        edit: editState,
      };
    }

    case FETCHING_CONVERSATION_SECTION_FAILED: {
      const { conversation, section, error } =
        action.payload as FetchConversationSectionErrorResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState || !conversationState.item) {
        return state;
      }

      const sections = (conversationState.item.sections || []).map((item) => {
        if (item.item?.id === section) {
          return {
            ...item,
            loading: false,
            error: error,
          };
        }

        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              sections: sections,
            },
          },
        },
      };
    }

    case FETCH_ASSETS_FOR_SECTION: {
      const { conversation, section } = action.payload as FetchAssetsForSection;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      const sections = (conversationState.sections || []).map((item) => {
        if (item?.id === section) {
          return {
            ...item,
            loading: true,
            loaded: false
          };
        }

        return item;
      }) as Sections[];

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            sections: sections,
          },
        },
      };
    }

    case FETCHING_ASSETS_FOR_SECTION_SUCCEEDED: {
      const { conversation, section, response } =
        action.payload as FetchAssetsForSectionResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      const sections = (conversationState.sections || []).map((item) => {
        if (item?.id === section) {
          return {
            ...item,
            assets: _.get(response, "assets", []),
            loading: false,
            loaded: true,
          };
        }

        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            sections: sections,
          },
        },
      };
    }

    case FETCHING_ASSETS_FOR_SECTION_FAILED: {
      const { conversation, section, error } =
        action.payload as FetchAssetsForSectionErrorResponse;

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      const sections = (conversationState.sections || []).map((item) => {
        if (item?.id === section) {
          return {
            ...item,
            loading: false,
            error: error,
          };
        }

        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
              sections: sections,
          },
        },
      };
    }

    case INVALIDATE_CONVERSATION_EDIT_STATE: {
      return {
        ...state,
        edit: null,
      };
    }

    case CREATE_CONVERSATION_SECTION_REQUEST: {
      const { name } = action.payload as CreateConversationSectionRequest;

      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      const sectionState = {
        uid: nanoid(6),
        loading: false,
        loaded: true,
        item: {
          name,
          collection: collectionState.id,
          entities: [],
        },
        error: null,
      };

      let sections = collectionState.sections || [];
      sections = [...sections, sectionState];

      return {
        ...state,
        edit: {
          ...collectionState,
          sections,
        },
      };
    }

    case REMOVE_CONVERSATION_SECTION_REQUEST: {
      const { index } = action.payload as RenameConversationSectionRequest;

      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      sections = sections.filter((item, i) => i !== index);

      return {
        ...state,
        edit: {
          ...collectionState,
          sections,
        },
      };
    }

    case UPDATE_CONVERSATION_SECTION_REQUEST: {
      const { index, name } =
        action.payload as RenameConversationSectionRequest;

      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      sections = sections.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            item: {
              ...item.item,
              name,
              entities: item.item?.entities || [],
            },
          };
        }

        return item;
      });

      return {
        ...state,
        edit: {
          ...collectionState,
          sections,
        },
      };
    }

    case MOVE_CONVERSATION_SECTION_REQUEST: {
      const { from, to } = action.payload as MoveConversationSectionRequest;

      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      sections = [...sections];
      sections.splice(to, 0, sections.splice(from, 1)[0]);

      return {
        ...state,
        edit: {
          ...collectionState,
          sections,
        },
      };
    }

    case CONVERSATION_ADD_ASSETS: {
      const { section, assets, addAt } =
        action.payload as AddAssetToConversationRequest;
      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      let existingAssets = collectionState.entities || [];

      if (section !== undefined) {
        sections = sections.map((item, index) => {
          if (index === section) {
            let existing = item.item?.entities || [];
            const contactCardExistsInTargetSection = getContactCardExists(existing);

            let assetsToBeAdded = [...assets];
            
            if (contactCardExistsInTargetSection) {
              assetsToBeAdded = assets.filter(
                (asset) => _.get(asset, "type", "ASSET") !== "CONTACT_CARD",
              );
            }

            if (addAt === "start") {
              existing = [...assetsToBeAdded, ...existing];
            } else {
              existing = [...existing, ...assetsToBeAdded];
            }

            existing = _.uniqBy(existing, "id");

            return {
              ...item,
              item: {
                ...item.item,
                name: item.item?.name || "",
                entities: existing,
              },
            };
          }

          return item;
        });
      } else {
        if (addAt === "start") {
          existingAssets = [...assets, ...existingAssets];
        } else {
          existingAssets = [...existingAssets, ...assets];
        }

        existingAssets = _.uniqBy(existingAssets, "id");
      }

      return {
        ...state,
        edit: {
          ...collectionState,
          sections: sections,
          entities: existingAssets,
        },
      };
    }

    case CONVERSATION_REMOVE_ASSETS: {
      const { section, asset } =
        action.payload as RemoveAssetFromConversationRequest;
      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      if (section !== undefined) {
        sections = sections.map((item, index) => {
          if (index === section) {
            return {
              ...item,
              item: {
                ...item.item,
                name: item.item?.name || "",
                entities: item.item?.entities?.filter((a) => a.id !== asset) || [],
              },
            };
          }

          return item;
        });
      }

      const assets = (collectionState.entities || []).filter(
        (a) => a.id !== asset,
      );

      return {
        ...state,
        edit: {
          ...collectionState,
          sections: sections,
          entities: assets,
        },
      };
    }

    case CONVERSATION_REARRANGE_ASSETS: {
      const { section, from, to } =
        action.payload as ArrangeAssetInConversationRequest;
      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      let sections = collectionState.sections || [];
      let assets = collectionState.entities || [];
      if (section !== undefined && sections.length > 0) {
        sections = sections.map((item, index) => {
          if (index === section) {
            let assets = item.item?.entities || [];
            assets = [...assets];

            const element = assets[from];
            assets.splice(from, 1);
            assets.splice(to, 0, element);

            assets = assets.map((asset, index) => {
              return {
                ...asset,
                order: index,
              };
            });

            return {
              ...item,
              item: {
                ...item.item,
                name: item.item?.name || "",
                entities: assets,
              },
            };
          }

          return item;
        });
      } else {
        assets = [...assets];
        const element = assets[from];
        assets.splice(from, 1);
        assets.splice(to, 0, element);
        
        assets = assets.map((asset, index) => ({
          ...asset,
          order: index
        }));
      }

      return {
        ...state,
        edit: {
          ...collectionState,
          sections: sections,
          entities: assets,
        },
      };
    }

    case CONVERSATION_UPDATE_ASSET_METADATA: {
      const { conversation, section, updates } =
        action.payload as UpdateAssetMetadataRequest;
      let collectionState = state.conversation[conversation]?.item;
      if (!collectionState) {
        return state;
      }

      let collectionEditState = state.edit;

      const applyUpdates = (
        assets: CollectionAsset[],
        updates: { id: string; metadata: any }[],
      ) => {
        return assets.map((asset) => {
          const update = updates.find((a) => a.id === asset.id);
          if (update) {
            return {
              ...asset,
              metadata: {
                ..._.get(asset, "metadata", {}),
                ..._.get(update, "metadata", {}),
              }
            };
          }

          return asset;
        });
      };

      const applyState = (
        entityState: CollectionEditState,
        updates: { id: string; metadata: any }[],
      ) => {
        let sections = entityState.sections || [];
        let updatedAssets = entityState.entities || [];
        if (section !== undefined) {
          sections = sections.map((item, index) => {
            if (index === section) {
              let assets = item.item?.entities || [];
              assets = [...assets];

              return {
                ...item,
                item: {
                  ...item.item,
                  name: item.item?.name || "",
                  entities: applyUpdates(assets, updates),
                },
              };
            }

            return item;
          });
        } else {
          updatedAssets = applyUpdates(updatedAssets, updates);
        }

        return {
          ...entityState,
          sections: sections,
          entities: updatedAssets,
        };
      };

      if (collectionEditState) {
        collectionEditState = applyState(collectionEditState, updates);
      } else {
        collectionState = applyState(collectionState, updates);
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...state.conversation[conversation],
            item: collectionState,
          },
        },
        edit: collectionEditState,
      };
    }

    case CONVERSATION_UPDATE_PROPERTY: {
      const { property, value } = action.payload as {
        property: string;
        value: any;
      };
      const collectionState = state.edit;
      if (!collectionState) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...collectionState,
          [property]: value,
        },
      };
    }

    case UPDATE_CONVERSATION_REQUEST: {
      const { id } = action.payload as UpdateConversationRequest;
      let updateState = state.update[id] || initialCollectionUpdateState;

      updateState = {
        ...updateState,
        id,
        updating: true,
        updated: false,
        item: null,
        error: null,
      };

      return {
        ...state,
        update: {
          ...state.update,
          [id]: updateState,
        },
      };
    }

    case UPDATING_CONVERSATION_SUCCEEDED: {
      const { response } = action.payload as UpdateConversationResponse;
      const id = response.id;
      if (!id) {
        return state;
      }

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      let editState = state.edit;
      if (editState?.id !== id) {
        editState = null;
      }

      let conversationState = state.conversation[id];
      if (conversationState) {
        const sections = (response.sections || []).map(
          (section, index): CollectionSectionState => {
            const existingSection = _.get(editState, `sections[${index}]`);

            if (existingSection) {
              return {
                uid: existingSection.uid,
                item: {
                  ...section,
                  collection: id,
                  entities: existingSection.item?.entities || [],
                },
                loading: existingSection.loading,
                loaded: existingSection.loaded,
                error: null,
              };
            }

            return {
              uid: nanoid(6),
              loading: true,
              loaded: false,
              item: {
                ...section,
                collection: id,
              },
              error: null,
            };
          },
        ) as CollectionSectionState[];

        conversationState = {
          ...conversationState,
          item: {
            ...response,
            sections: sections || [],
          },
        };
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: true,
            item: response,
            error: null,
          },
        },
        conversation: {
          ...state.conversation,
          [id]: conversationState,
        },
      };
    }

    case UPDATING_CONVERSATION_FAILED: {
      const { id, error } = action.payload as UpdateConversationErrorResponse;
      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: false,
            error: error,
          },
        },
      };
    }

    case ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED: {
      const { response } = action.payload as AddAssetToConversationResponse;
      if (!response || !response.id) {
        return state;
      }

      const conversationState = state.conversation[response.id];
      if (!conversationState) {
        return state;
      }

      const sections = (response.sections || []).map(
        (section): CollectionSectionState => {
          return {
            uid: nanoid(6),
            loading: true,
            loaded: false,
            item: {
              ...section,
              collection: response.id,
            },
            error: null,
          } as CollectionSectionState;
        },
      ) as CollectionSectionState[];

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [response.id]: {
            ...conversationState,
            loading: false,
            loaded: true,
            loadingAssets: false,
            loadedAssets: false,
            item: {
              ...response,
              sections: sections || [],
            },
            error: null,
          },
        },
      };
    }

    case ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED: {
      const { conversation, response } =
        action.payload as AddAssetToConversationResponse;

      if (!response || !response.id) {
        return state;
      }

      const conversationState = state.conversation[conversation];
      if (!conversationState) {
        return state;
      }

      const sections = (conversationState.item?.sections || []).map((item) => {
        if (item.item?.id === response.id) {
          return {
            ...item,
            item: {
              ...item.item,
              collection: conversation,
              assets: response.assets,
            },
            loading: false,
            loaded: true,
          } as CollectionSectionState;
        }

        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversation]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              sections: sections,
            },
          },
        },
      };
    }

    case REMOVE_OPPORTUNITY_FROM_SHARE: {
      const { conversationId, opportunityId } =
        action.payload as RemoveOpportunityFromConversationRequest;
      const conversationState = state.conversation[conversationId];

      const opportunities = (
        _.get(conversationState, "item.opportunities") || []
      ).map((opportunity: Opportunity) => {
        if (opportunity.id === opportunityId) {
          return {
            ...opportunity,
            removing: true,
          };
        }

        return opportunity;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              opportunities,
            },
          },
        },
      };
    }

    case REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED: {
      const { conversationId, opportunityId } =
        action.payload as RemoveOpportunityFromConversationRequest;
      const conversationState = state.conversation[conversationId];

      const opportunities = (
        _.get(conversationState, "item.opportunities") || []
      ).filter((opportunity: Opportunity) => opportunity.id !== opportunityId);

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            item: {
              ...conversationState.item,
              opportunities,
            },
          },
        },
      };
    }

    case REMOVING_OPPORTUNITY_FROM_SHARE_FAILED: {
      const { conversationId, opportunityId, error } =
        action.payload as RemoveOpportunityFromConversationErrorResponse;
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...state.conversation[conversationId],
            item: {
              ...state.conversation[conversationId].item,
              opportunities: (
                state.conversation[conversationId].item?.opportunities || []
              ).map((opportunity: Opportunity) => {
                if (opportunity.id === opportunityId) {
                  return {
                    ...opportunity,
                    removing: false,
                    removed: false,
                    error: error,
                  };
                }
                return opportunity;
              }),
            },
          },
        },
      };
    }

    case FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST: {
      const { shareId, recipientId } =
        action.payload as FetchRecipientInfoRequest;
      const conversationState = state.conversation[shareId];

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };
      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            loadingActivity: true,
          };
        }
        return item;
      });
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED: {
      const { shareId, recipientId, response } =
        action.payload as FetchRecipientInfoResponse;
      const conversationState = state.conversation[shareId];
      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };
      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        let updatingActivity = item.updatingActivity;
        if (id === recipientId) {
          if (updatingActivity === true) {
            updatingActivity = false;
          }
          return {
            ...item,
            loadingActivity: false,
            activity: response,
            updatingActivity,
          };
        }
        return item;
      });
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED: {
      const { shareId, recipientId, error } =
        action.payload as FetchRecipientInfoErrorResponse;
      const conversationState = state.conversation[shareId];

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            updating: false,
            error: error,
          };
        }
        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case UPDATE_CONVERSATION_RECIPENT_REQUEST: {
      const { conversationId, recipientId } =
        action.payload as UpdateConversationRecipientRequest;

      const conversationState = state.conversation[conversationId];

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            updating: true,
          };
        }
        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case UPDATING_CONVERSATION_RECIPENT_SUCCEEDED: {
      const { conversationId, recipientId, response } =
        action.payload as UpdateConversationRecipientResponse;

      const conversationState = state.conversation[conversationId];

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            updating: false,
            accessRemovedDate: response.accessRemovedDate,
            active: response.active,
          };
        }
        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case UPDATING_CONVERSATION_RECIPENT_FAILED: {
      const { conversationId, recipientId, error } =
        action.payload as UpdateConversationRecipientErrorResponse;

      const conversationState = state.conversation[conversationId];

      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            updating: false,
            error: error,
          };
        }
        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case TOGGLE_VISITOR_SESSION: {
      const { conversationId, recipientId } =
        action.payload as ToggleVisitorSessionRequest;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }
      const conversationRecipientsState = conversationState.recipients || {
        loading: true,
        loaded: false,
        error: null,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
      };

      const recipients = conversationRecipientsState.items.map((item) => {
        const id = _.get(item, "contact.id") || _.get(item, "visitor.id") || "";
        if (id === recipientId) {
          return {
            ...item,
            updatingActivity: true,
          };
        }
        return item;
      });

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            recipients: {
              ...conversationRecipientsState,
              items: recipients,
            },
          },
        },
      };
    }

    case FETCH_CONVERSATION_EVENTS: {
      const { request } = action.payload as FetchConversationEventsRequest;

      const conversationState = state.conversation[request.share];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [request.share]: {
            ...conversationState,
            events: {
              ...conversationState.events,
              loading: true,
            },
          },
        },
      };
    }

    case FETCHING_CONVERSATION_EVENTS_SUCCEEDED: {
      const { request, data } =
        action.payload as FetchConversationEventsResponse;

      const conversationState = state.conversation[request.share];

      if (!conversationState) {
        return state;
      }

      const currentPage = data.currentPage;
      const existingItems = _.get(conversationState, "events.items") || [];
      let records = data.records;
      if (currentPage > 0) {
        records = [...existingItems, ...records];
      }
      records = _.uniqBy(records, "id");

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [request.share]: {
            ...conversationState,
            events: {
              loading: false,
              loaded: true,
              items: records,
              pagination: {
                currentPage: data.currentPage,
                totalPages: data.totalPages,
                recordsPerPage: data.recordsPerPage,
                totalRecordsCount: data.totalRecordsCount,
              },
            },
          },
        },
      };
    }

    case FETCHING_CONVERSATION_EVENTS_FAILED: {
      const { request, error } =
        action.payload as FetchConversationEventsErrorResponse;

      const conversationState = state.conversation[request.share];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [request.share]: {
            ...conversationState,
            events: {
              loading: false,
              loaded: false,
              error: error,
            },
          },
        },
      };
    }

    case SEARCHING_ENTITIES_IN_SHARE_REQUEST: {
      const { shareId } = action.payload as SearchEntitiesInShareRequest;

      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            shareEntities: {
              loading: true,
              error: null,
              items: null,
              succeeded: false,
            },
          },
        },
      };
    }

    case SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED: {
      const { shareId, response } =
        action.payload as SearchEntitiesInShareResponse;

      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            shareEntities: {
              loading: false,
              items: response,
              succeeded: true,
              error: null,
            },
          },
        },
      };
    }

    case SEARCHING_ENTITIES_IN_SHARE_FAILED: {
      const { shareId, error } =
        action.payload as SearchEntitiesInShareErrorResponse;

      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            shareEntities: {
              loading: false,
              items: null,
              succeeded: false,
              error: error,
            },
          },
        },
      };
    }

    case ADD_OPPORTUNITY_TO_SHARE: {
      const { conversationId } = action.payload as AddOpportunityToShare;
      const conversationState = state.conversation[conversationId];

      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            addingDeal: true,
            addedDeal: false,
          },
        },
      };
    }

    case ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED: {
      const { conversationId, response } =
        action.payload as AddOpportunityToShareResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            addingDeal: false,
            addedDeal: true,
            item: {
              ...conversationState.item,
              opportunities: _.uniqBy(
                [...(conversationState.item?.opportunities || []), response],
                "id",
              ),
            },
          },
        },
      };
    }

    case ADDING_OPPORTUNITY_TO_SHARE_FAILED: {
      const { conversationId, error } =
        action.payload as AddOpportunityToShareErrorResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            addingDeal: false,
            addedDeal: false,
            error: error,
          },
        },
      };
    }

    case DELETE_CONVERSATION_REQUEST: {
      const { id } = action.payload as DeleteConversationRequest;
      const deleteState = state.delete[id] || initialConvesationDeleteState;

      return {
        ...state,
        delete: {
          ...state.delete,
          [id]: {
            ...deleteState,
            deleting: true,
            deleted: false,
            error: null,
          },
        },
      };
    }

    case DELETING_CONVERSATION_SUCCEEDED: {
      const { id } = action.payload as DeleteConversationResponse;
      const deleteState = state.delete[id];
      if (!deleteState) {
        return state;
      }

      const updatedConversations = state.conversations.items.filter(
        (item) => id !== item.id,
      );

      return {
        ...state,
        conversations: {
          ...state.conversations,
          items: updatedConversations,
        },
        delete: {
          ...state.delete,
          [id]: {
            ...deleteState,
            deleting: false,
            deleted: true,
            error: null,
          },
        },
      };
    }

    case DELETING_CONVERSATION_FAILED: {
      const { id, error } = action.payload as DeleteConversationErrorResponse;
      const deleteState = state.delete[id];
      if (!deleteState) {
        return state;
      }

      return {
        ...state,
        delete: {
          ...state.delete,
          [id]: {
            ...deleteState,
            deleting: false,
            deleted: false,
            error: error,
          },
        },
      };
    }

    case FETCH_MESSAGE_REQUEST: {
      const { shareId } = action.payload as FetchMessageRequest;
      const conversationState = state.conversation[shareId];
      if (!conversationState) {
        return state;
      }

      const messageState = conversationState.message || {
        loading: true,
        loaded: false,
        item: null,
      };
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            message: {
              ...messageState,
              loading: true,
              loaded: false,
              item: null,
            },
          },
        },
      };
    }

    case FETCHING_MESSAGE_SUCCEEDED: {
      const { shareId, response } = action.payload as FetchingMessageResponse;
      const conversationState = state.conversation[shareId];
      if (!conversationState) {
        return state;
      }

      const messageState = conversationState.message || {
        loading: true,
        loaded: false,
        item: null,
      };

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            message: {
              ...messageState,
              loading: false,
              loaded: true,
              item: response,
            },
          },
        },
      };
    }

    case FETCHING_MESSAGE_FAILED: {
      const { shareId, error } = action.payload as FetchingMessageErrorResponse;
      const conversationState = state.conversation[shareId];
      if (!conversationState) {
        return state;
      }

      const messageState = conversationState.message || {
        loading: true,
        loaded: false,
        item: null,
      };

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
            message: {
              ...messageState,
              loading: false,
              loaded: false,
              error: error,
            },
          },
        },
      };
    }

    case RESEND_CONVERSATION_REQUEST: {
      const { conversationId } = action.payload as ResendMessageRequest;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }
      const messageState = conversationState.message || {
        loading: true,
        loaded: false,
        item: null,
      };
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            message: {
              ...messageState,
              resending: true,
            },
          },
        },
      };
    }

    case RESENDING_CONVERSATION_SUCCEEDED: {
      const { conversationId } = action.payload as ResendMessageResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }
      const messageState = conversationState.message || {
        loading: false,
        loaded: false,
        item: null,
      };

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            message: {
              ...messageState,
              resending: false,
            },
          },
        },
      };
    }

    case RESENDING_CONVERSATION_FAILED: {
      const { conversationId, error } =
        action.payload as ResendMessageErrorResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }
      const messageState = conversationState.message || {
        loading: false,
        loaded: false,
        item: null,
      };

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            message: {
              ...messageState,
              resending: false,
              error,
            },
          },
        },
      };
    }

    case INVALIDATE_RESHARE: {
      const { conversationId } = action.payload as InvalidateReshare;
      const conversationState = state.conversation[conversationId];
      const messageState = conversationState.message;
      if (!conversationState || !messageState) {
        return state;
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
            message: {
              ...messageState,
              resending: null,
            },
          },
        },
      };
    }

    case FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST: {
      const { conversationId, assetId, sectionId } =
        action.payload as FetchConversationAssetAnalyticsRequest;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [conversationId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                      item: {
                        ...section,
                        assets: section.assets.map((asset) => {
                          if (asset.id === assetId) {
                            return {
                              ...asset,
                              fetchingAnalytics: true,
                              fetchedAnalytics: false,
                            };
                          }
                          return asset;
                        }),
                      },
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === assetId) {
                    return {
                      ...asset,
                      fetchingAnalytics: true,
                      fetchedAnalytics: false,
                    };
                  }
                  return asset;
                },
              ),
            },
          },
      };
    }

    case FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED: {
      const { conversationId, assetId, response, sectionId } =
        action.payload as FetchConversationAssetAnalyticsResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [conversationId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                        assets: section.assets.map((asset) => {
                          if (asset.id === assetId) {
                            return {
                              ...asset,
                              fetchingAnalytics: false,
                              fetchedAnalytics: true,
                              analytics: response,
                            };
                          }
                          return asset;
                        }),
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === assetId) {
                    return {
                      ...asset,
                      fetchingAnalytics: false,
                      fetchedAnalytics: true,
                      analytics: response,
                    };
                  }
                  return asset;
                },
              ),
            },
          },
      };
    }

    case FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED: {
      const { conversationId, assetId, error, sectionId } =
        action.payload as FetchConversationAssetAnalyticsErrorResponse;
      const conversationState = state.conversation[conversationId];
      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [conversationId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                        assets: section.assets.map((asset) => {
                          if (asset.id === assetId) {
                            return {
                              ...asset,
                              fetchingAnalytics: false,
                              fetchedAnalytics: false,
                              error: error,
                            };
                          }
                          return asset;
                        }),
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }

      return {
        ...state,
        conversation: {
          ...state.conversation,
          [conversationId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === assetId) {
                    return {
                      ...asset,
                      fetchingAnalytics: false,
                      fetchedAnalytics: false,
                      error: error,
                    };
                  }
                  return asset;
                },
              ),
          },
        },
      };
    }

    case FETCHING_PREVIEW_ASSET: {
      const { id, shareId, sectionId } = action.payload as FetchPreviewAsset;

      if (!shareId) {
        return state;
      }
      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [shareId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                        assets: section.assets.map((asset) => {
                          const assetItem = asset;
                          if (asset.id === id) {
                            return {
                              ...asset,
                              asset: {
                                ...assetItem,
                                preview: {
                                  loading: true,
                                  item: null,
                                  fetch: false,
                                },
                              },
                            };
                          }
                          return asset;
                        }),
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === id) {
                    return {
                      ...asset,
                      preview: {
                        loading: true,
                        item: null,
                        fetch: false,
                      },
                    };
                  }
                  return asset;
                },
              ),
            },
        },
      };
    }

    case FETCHING_PREVIEW_ASSET_SUCCEEDED: {
      const { id, shareId, sectionId, response } =
        action.payload as FetchPreviewAssetResponse;

      if (!shareId) {
        return state;
      }
      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [shareId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                        assets: section.assets.map((asset) => {
                          if (asset.id === id) {
                            return {
                              ...asset,
                              preview: {
                                loading: false,
                                item: response,
                                fetch: true,
                              },
                            };
                          }
                          return asset;
                        }),
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === id) {
                    return {
                      ...asset,
                      preview: {
                        loading: false,
                        item: response,
                        fetch: true,
                      },
                    };
                  }
                  return asset;
                },
              ),
          },
        },
      };
    }

    case FETCHING_PREVIEW_ASSET_FAILED: {
      const { id, shareId, sectionId, error } =
        action.payload as FetchPreviewAssetErrorResponse;

      if (!shareId) {
        return state;
      }
      const conversationState = state.conversation[shareId];

      if (!conversationState) {
        return state;
      }

      if (sectionId) {
        const sections = conversationState?.sections || [];
        return {
          ...state,
          conversation: {
            ...state.conversation,
            [shareId]: {
              ...conversationState,
                sections: sections.map((section) => {
                  if (section?.id === sectionId) {
                    return {
                      ...section,
                        assets: section.assets.map((asset) => {
                          if (asset.id === id) {
                            return {
                              ...asset,
                                preview: {
                                  loading: false,
                                  item: null,
                                  fetch: false,
                                  error: error,
                                },
                            };
                          }
                          return asset;
                        }),
                    };
                  }
                  return section;
                }),
              },
            },
        };
      }
      return {
        ...state,
        conversation: {
          ...state.conversation,
          [shareId]: {
            ...conversationState,
              assets: _.get(conversationState, "assets", []).map(
                (asset) => {
                  if (asset.id === id) {
                    return {
                      ...asset,
                      preview: {
                        loading: false,
                        item: null,
                        fetch: false,
                        error: error,
                      },
                    };
                  }
                  return asset;
                },
              ),
            },
          },
      };
    }

    case INVALIDATE_CONVERSATION_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}